import React, { useState, useEffect } from 'react';
import { WebApp } from '@twa-dev/sdk';
import { authTelegram, getProfile, getInsights } from '~/lib/api.ts';
import { HomeScreen } from './components/HomeScreen';
import { LogScreen } from './components/LogScreen';
import { TodayScreen } from './components/TodayScreen';
import { AIScreen } from './components/AIScreen';
import { LoadingScreen } from './components/LoadingScreen';
import { ErrorScreen } from './components/ErrorScreen';
import { UserProfile, InsightsResponse } from '~/lib/api.ts';

type Screen = 'loading' | 'error' | 'home' | 'log' | 'today' | 'ai';

function App() {
  const [currentScreen, setCurrentScreen] = useState<Screen>('loading');
  const [user, setUser] = useState<UserProfile | null>(null);
  const [insights, setInsights] = useState<InsightsResponse | null>(null);
  const [error, setError] = useState<string>('');

  useEffect(() => {
    initializeApp();
  }, []);

  const initializeApp = async () => {
    try {
      // Инициализируем Telegram WebApp
      WebApp.ready();
      WebApp.expand();

      // Авторизуемся через Telegram
      const authResponse = await authTelegram();
      if (!authResponse.token) {
        throw new Error('Authentication failed');
      }

      // Получаем профиль пользователя
      const userProfile = await getProfile();
      setUser(userProfile);

      // Получаем инсайты
      const insightsData = await getInsights();
      setInsights(insightsData);

      setCurrentScreen('home');
    } catch (err) {
      console.error('App initialization error:', err);
      setError(err instanceof Error ? err.message : 'Unknown error');
      setCurrentScreen('error');
    }
  };

  const refreshData = async () => {
    try {
      const userProfile = await getProfile();
      setUser(userProfile);
      
      const insightsData = await getInsights();
      setInsights(insightsData);
    } catch (err) {
      console.error('Data refresh error:', err);
    }
  };

  const handleScreenChange = (screen: Screen) => {
    setCurrentScreen(screen);
  };

  const handleBack = () => {
    setCurrentScreen('home');
  };

  if (currentScreen === 'loading') {
    return <LoadingScreen />;
  }

  if (currentScreen === 'error') {
    return <ErrorScreen error={error} onRetry={initializeApp} />;
  }

  return (
    <div className="app">
      {currentScreen === 'home' && (
        <HomeScreen
          user={user}
          insights={insights}
          onLogClick={() => handleScreenChange('log')}
          onTodayClick={() => handleScreenChange('today')}
          onAIClick={() => handleScreenChange('ai')}
          onRefresh={refreshData}
        />
      )}
      
      {currentScreen === 'log' && (
        <LogScreen onBack={handleBack} onDataLogged={refreshData} />
      )}
      
      {currentScreen === 'today' && (
        <TodayScreen insights={insights} onBack={handleBack} />
      )}
      
      {currentScreen === 'ai' && (
        <AIScreen onBack={handleBack} />
      )}
    </div>
  );
}

export default App;
